import Phaser from 'phaser';
import { OptionsMenuForm } from '@/scenes/OptionsMenuForm';
import { PauseMenuState } from '@/systems/PauseMenuState';
import { ACTIVE_SLOT, DEFAULT_OPTIONS, getSaveManager } from '@/systems/SaveManager';
import { OPTION_VOLUME_STEP } from '@/systems/OptionsMenuActions';

const OVERLAY_DEPTH = 1000;

interface OptionsSceneInit {
  readonly returnScene?: string;
}

export class OptionsScene extends Phaser.Scene {
  private returnScene = 'TitleScene';
  private state!: PauseMenuState;
  private form!: OptionsMenuForm;

  constructor() {
    super({ key: 'OptionsScene' });
  }

  init(data: OptionsSceneInit = {}): void {
    this.returnScene = data.returnScene ?? 'TitleScene';
  }

  create(): void {
    const { width, height } = this.scale;
    const slot = getSaveManager().load(ACTIVE_SLOT);
    const savedOpts = slot?.options ?? { ...DEFAULT_OPTIONS };
    this.state = new PauseMenuState(savedOpts);
    this.state.enterOptions();

    this.add
      .rectangle(width / 2, height / 2, width, height, 0x000000, 0.88)
      .setDepth(OVERLAY_DEPTH);

    this.form = new OptionsMenuForm(this, this.state);
    this.form.build(width, height);
    this.form.setVisible(true);
    this.bindKeys();
  }

  private bindKeys(): void {
    const kb = this.input.keyboard!;
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.UP).on('down', () => this.form.moveUp());
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN).on('down', () => this.form.moveDown());
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.LEFT).on('down', () =>
      this.form.adjust(-OPTION_VOLUME_STEP),
    );
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.RIGHT).on('down', () =>
      this.form.adjust(OPTION_VOLUME_STEP),
    );
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.W).on('down', () => this.form.moveUp());
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.S).on('down', () => this.form.moveDown());
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.A).on('down', () =>
      this.form.adjust(-OPTION_VOLUME_STEP),
    );
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.D).on('down', () =>
      this.form.adjust(OPTION_VOLUME_STEP),
    );
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER).on('down', () => this.onConfirm());
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE).on('down', () => this.onConfirm());
    kb.addKey(Phaser.Input.Keyboard.KeyCodes.ESC).on('down', () => this.onBack());
  }

  private onConfirm(): void {
    const result = this.form.confirm();
    if (result.back) {
      this.onBack();
    }
  }

  private onBack(): void {
    this.persistOptions();
    this.scene.start(this.returnScene);
  }

  private persistOptions(): void {
    getSaveManager().saveOptions(ACTIVE_SLOT, { ...this.state.opts }, Date.now());
  }
}
